import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";

// Polls for prospects waiting in a Video Support lobby and toasts the
// super-admin host in-app so no one waits unnoticed. Renders nothing.
export function WaitingRoomPinger() {
  const { user } = useAuth();
  const seen = useRef(new Set());

  useEffect(() => {
    if (!user || user.role !== "super_admin") return undefined;
    let alive = true;
    const check = async () => {
      try {
        const r = await api.get("/video/waiting");
        if (!alive) return;
        for (const w of r.data || []) {
          const key = `${w.token}:${w.at}`;
          if (seen.current.has(key)) continue;
          seen.current.add(key);
          toast(`${w.guest_name || "Someone"} is waiting in your demo`, {
            description: `They just joined the lobby for "${w.title || "your demo"}"`,
            duration: 20000,
            action: {
              label: "Join call",
              onClick: () => window.open(`/call/${w.token}?host=1`, "_blank", "noopener"),
            },
          });
        }
      } catch { /* ignore */ }
    };
    check();
    const id = setInterval(check, 12000);
    return () => { alive = false; clearInterval(id); };
  }, [user]);

  return null;
}

export default WaitingRoomPinger;
